import { C } from '../constants';
import ConfidenceBadge from './ConfidenceBadge';

export default function ConfidenceBanner({ level, gaps }) {
  if (!level) return null;
  const cfg = {
    high:   { msg:"Strong data quality — all key inputs sourced from live data.",                bg:"rgba(0,200,5,0.06)",     border:"rgba(0,200,5,0.2)",     color:C.green   },
    medium: { msg:"Good data quality — most inputs found; some estimated.",                      bg:"rgba(201,168,76,0.06)",  border:"rgba(201,168,76,0.2)",  color:C.gold2   },
    low:    { msg:"Limited data — several inputs estimated. Treat results as directional only.", bg:"rgba(255,59,48,0.06)",   border:"rgba(255,59,48,0.2)",   color:"#FCA5A5" },
  }[level] || {};
  return (
    <div style={{ background:cfg.bg, border:`1px solid ${cfg.border}`, borderRadius:12, padding:"12px 14px", marginBottom:14 }}>
      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:gaps?.length?5:0 }}>
        <ConfidenceBadge level={level} size="md"/>
        <span style={{ fontSize:12, color:cfg.color }}>{cfg.msg}</span>
      </div>
      {gaps?.length>0 && <div style={{ fontSize:11, color:C.hint, lineHeight:1.65, marginTop:4 }}><strong style={{ color:C.soft }}>Data notes: </strong>{Array.isArray(gaps)?gaps.slice(0,3).join(" · "):String(gaps)}</div>}
    </div>
  );
}
